import React from "react";
import { Link } from "react-router-dom";

const WorkProcess = () => {
  return (
    <>
      <section className="pb-50 about-three-area sub-bg pt-120">
        <div
          className="about__shape wow slideInLeft"
          data-wow-delay="400ms"
          data-wow-duration="1500ms"
        >
          <img src="/assets/images/shape/about-three-line.png" alt="shape" />
        </div>
        <div
          className="about-three__box-up wow slideInRight"
          data-wow-delay="00ms"
          data-wow-duration="1500ms"
        >
          <img
            className="sway_Y__animationY"
            src="/assets/images/shape/about-three-box-up.png"
            alt="shape"
          />
        </div>
        <div
          className="about-three__box-down wow slideInRight"
          data-wow-delay="200ms"
          data-wow-duration="1500ms"
        >
          <img
            className="sway_Y__animation"
            src="/assets/images/shape/about-three-box-down.png"
            alt="shape"
          />
        </div>
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-lg-5 order-2 order-lg-1">
              <div className="about-three__left-item">
                <div className="section-header mb-40">
                  <h5
                    className="wow fadeInUp fs-3"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <img
                      className="me-1 h-40 w-40 object-fit-cover"
                      src="/assets/images/icon/section-title.png"
                      alt="icon"
                    />
                    Coempt
                  </h5>
                  <h2
                    className="wow fadeInUp fs-4"
                    data-wow-delay="200ms"
                    data-wow-duration="1500ms"
                  >
                    Why Coempt?
                  </h2>
                  <p
                    className="wow fadeInUp"
                    data-wow-delay="400ms"
                    data-wow-duration="1500ms"
                  >
                    With over 25 years of dedicated experience, Coempt Edu Teck
                    stands as a premier leader in the EdTech sector,
                    specializing in comprehensive, end-to-end examination
                    solutions for awarding bodies and educational institutions.
                    Our proven track record and extensive portfolio are designed
                    to demonstrating an unmatched commitment to technological
                    excellence, security, scalability, and a deep-seated mission
                    to bridge the digital divide in examinations. Through our
                    robust, innovative solutions we empower awarding bodies and
                    educational institutions to practice absolute transparency
                    and good governance, impacting key stakeholders be it
                    students, faculty, and education administrators.
                  </p>
                </div>
                <div className="d-flex justify-content-end ">
                  <Link
                    to="/whycoempt"
                    className="btn-one wow fadeInUp"
                    data-wow-delay="200ms"
                    data-wow-duration="1500ms"
                  >
                    View More
                    <i className="fa-regular fa-arrow-right-long" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-7 order-1 order-lg-2">
              <div
                className="faq__image about-three__image image wow fadeInRight"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                <div className="about-three-dot">
                  <img
                    className="sway__animationX"
                    src="/assets/images/shape/about-three-dot.png"
                    alt="shape"
                  />
                </div>
                <div className="about-three-count p-4 d-flex align-items-center gap-3">
                  <img
                    className="icon"
                    src="/assets/images/icon/about-three-icon3.png"
                    alt="icon"
                  />
                  <div className="con">
                    <h3>
                      <span className="count">6,561</span>+
                    </h3>
                    <span className="secondary-color sm-font">
                      Satisfied Clients
                    </span>
                  </div>
                </div>
                <div className="faq__line sway__animation">
                  <img src="/assets/images/shape/faq-line.png" alt="image" />
                </div>
                <img
                  src="/assets/images/about/about-three-image.png"
                  alt="image"
                  className="z-index-1"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <div className="banner-video-area" style={{ marginTop: "-190px" }}>
        <div className="container">
          <div className="banner-video__wrp image">
            <img src="assets/images/video/video-image1.jpg" alt="image" />
            <div className="banner-video__video-btn">
              <div
                className="video-btn video-pulse wow fadeIn"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                <a
                  className="video-popup"
                  to="https://www.youtube.com/watch?v=iVqz_4M5mA0"
                >
                  <i className="fa-solid fa-play" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default WorkProcess;
